import restCrudActions from '../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../np-rest/rest';
import { snackActions } from '../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'network-zone',
    pluginName: 'NETWORK_ZONE',
    entityName: 'NETWORK_ZONE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch networkZone action creators
export const fetchNetworkZoneInit = () => {
    return crudActions.fetchInit();
};
export const fetchNetworkZoneStart = () => {
    return crudActions.fetchStart();
};
export const fetchNetworkZoneSuccess = (fetchNetworkZoneCount, listNetworkZoneCount) => {
    return crudActions.fetchSuccess(fetchNetworkZoneCount, listNetworkZoneCount);
};
export const fetchNetworkZoneFail = () => {
    return crudActions.fetchFail();
};
export const fetchNetworkZoneCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchNetworkZoneStart());
        try {
            let countRes = await rest.post("network-zone/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchNetworkZoneSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchNetworkZoneFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch network zone."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchNetworkZoneFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch network zone."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};


export const fetchNetworkZone = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchNetworkZoneStart());
        try {
            let listRes = await rest.post("network-zone/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchNetworkZoneSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchNetworkZoneFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchNetworkZoneFail());

            return { data: [] };
        }
    }
};


// Load networkZone action creators
export const loadNetworkZoneInit = () => { return crudActions.loadInit() };
export const loadNetworkZoneStart = () => { return crudActions.loadStart(); };
export const loadNetworkZoneSuccess = loadedNetworkZone => { return crudActions.loadSuccess(loadedNetworkZone); };
export const loadNetworkZoneFail = error => { return crudActions.loadFail(error); };
export const loadNetworkZone = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

// Create networkZone  action creators
export const createNetworkZoneInit = () => {
    return crudActions.createInit();
};
export const createNetworkZoneStart = () => {
    return crudActions.createStart();
};
export const createNetworkZoneSuccess = createdNetworkZone => {
    return crudActions.createSuccess(createdNetworkZone);
};
export const createNetworkZoneFail = error => {
    return crudActions.createFail(error);
};

export const createNetworkZone = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createNetworkZoneStart());
        try {
            let res = await rest.post('/network-zone/create', params);
            if (res.data && res.data.succeeded) {
                // Next line is commented because of cancel request, will be removed
                //dispatch(createNetworkZoneSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: res?.data?.message ?? `Successfully created network zone.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createNetworkZoneFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create network zone."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create network zone."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createNetworkZoneFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit networkZone  action creators
export const editNetworkZoneInit = () => {
    return crudActions.editInit();
};
export const editNetworkZoneStart = () => {
    return crudActions.editStart();
};
export const editNetworkZoneSuccess = editedNetworkZone => {
    return crudActions.editSuccess(editedNetworkZone);
};
export const editNetworkZoneFail = error => {
    return crudActions.editFail(error);
};

export const editNetworkZone = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editNetworkZoneStart());
        try {
            let res = await rest.post('/network-zone/save', params);
            if (res.data && res.data.succeeded) {
                // Next line is commented because of cancel request, will be removed
                //dispatch(editNetworkZoneSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated network zone.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editNetworkZoneFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit network zone."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit network zone."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editNetworkZoneFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete product type 
export const bulkDeleteNetworkZonesInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteNetworkZonesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteNetworkZonesSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteNetworkZonesFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteNetworkZones = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteNetworkZonesStart());
        try {
            let res = await rest.post('/network-zone/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteNetworkZonesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted network zone.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteNetworkZonesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete network zone."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete network zone."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteNetworkZonesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const listPermissions = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/permissions/list', { listAll: true, ...data }, options);
            if (res.data && res.data.succeeded) {
                let permissions = [];
                for (var permission of res.data.result.data) {
                    permissions.push({ value: permission.PermissionID, label: `${permission.Name}` });
                }
                return permissions;
            } else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list permissions."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}

export const listCustomers = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/list', { listAll: true, ...data });
            if (res.data && res.data.succeeded) {
                let customers = [];
                for (var customer of res.data.result.data) {
                    customers.push({ value: customer.CustomerID, displayValue: `${customer.Name}` });
                }
                return customers;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list customer."}`,
                options: {
                    variant: 'warning'
                }
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}

export const whoIs = () => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/network-zone/who-is', {});
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    };
}
